<mat-expansion-panel #panel class="mat-elevation-z1" [expanded]="this.expanded">
  <mat-expansion-panel-header style="background-color: whitesmoke;">
    <mat-panel-title class="avenir-font">
      {{this.label}}
    </mat-panel-title>
    <mat-panel-description class="justify-content-end">
      <mat-icon [ngStyle]="{'color': items.length > 0 ? '#9E81E4' : '#999'}">{{iconName}}</mat-icon>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div class="d-flex flex-column mt-4">
    <mat-checkbox *ngFor="let item of elements" [(ngModel)]="item.checked" color="primary" (change)="onSelectionChanged(item.name,$event)" class="avenir-font">
      {{ item.name }}
    </mat-checkbox>
  </div>
</mat-expansion-panel>




